import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import userInfo from '../pages/user/userinfo/userinfo'
import exhibitionRecord from '../pages/user/exhibitionRecord/exhibitionRecord'
import attendancerecord from '../pages/user/attendancerecord/attendancerecord'
import jobList from '../pages/user/attendancerecord/jobList'
import visitortickets from '../pages/user/visitortickets/visitortickets'
import onlineResume from '../pages/user/onlineResume/onlineResume'
import ticketsExhibition from '../pages/user/ticketsExhibition/ticketsExhibition'
import subaccountManagement from '../pages/user/subaccountManagement/subaccountManagement'
import broadcastoto from '../pages/user/broadcastoto/broadcastoto'
import bbs from '../pages/user/bbs/bbs'
import exhibitionList from '../pages/user/exhibitionList/exhibitionList'
import exhibitionwrap from '../pages/user/exhibitionwrap/exhibitionwrap'
import experience from '../pages/user/experience/experience'
import experiencegz from '../pages/user/experiencegz/experiencegz'
import guestList from '../pages/user/guestList/guestList'
import orderList from '../pages/user/orderList/orderList'
import editpassword from '../pages/user/editpassword/editpassword'
// import createdBBS from '../pages/user/createdBBS/index'
import appointments from "../pages/user/appointments/index"
import Layout from "../pages/user/Layout/index";
import {language} from "../language/get";
import noticeList from '../pages/user/notice/noticeList'
const lan = language();


function getCookies() {
  let user =  localStorage.getItem("user");
  if(!user||user==null||user=="undefined"){
    // Cook.del("token");
    localStorage.removeItem("token")
    return {}
  }else {
    // console.log(user);
    return JSON.parse(user);
  }
}
let userData = getCookies();
if(userData == {}){
    userData.user_nature=1;
    userData.superioruser_id=0;
}
let user_nature = userData.user_nature;
let superioruser_id = userData.superioruser_id;
export const constantRoutes = [

    {
        //展商管理
        name: "exhibitionwrap",
        component: Layout,
        path: "/exhibitionList",
        hidden: false,
        // meta: {title: lan.sidebarName.guestList, icon: "guestlist", icon_on: 'guestlist'},
        meta: {title: user_nature==1?'招聘企业信息':'应聘者简历', icon: "directories", icon_on: 'directories_on'},
        children:[{
            path:'/exhibitionList',
            name:'exhibitionwrap',
            hidden: true,
            component:exhibitionwrap,
            meta: {title: user_nature==1?'招聘企业信息':'应聘者简历', icon: "circle", icon_on: 'circle_on' },
            children: [
                {
                    path:'/exhibitionList/',
                    name:'exhibitionList',
                    hidden: false,
                    component:exhibitionList,
                },
                {
                    path:'/exhibitionList/guestList',
                    name:'guestList',
                    hidden: false,
                    component:guestList,
                }
            ]
        },]
    },
    {
        //展商管理
        name: "exhibitorAdmin",
        component: Layout,
        path: "/exhAdmin",
        hidden: false,
        // meta: {title: lan.sidebarName.exhibitorAdmin, icon: "seat", icon_on: 'seat_on'},
        meta: {title: user_nature==1?'应聘管理':'招聘管理',icon: "recruit", icon_on: 'recruit_on' },
        children: [
            {
                //观展门票
                path:'/visitortickets',
                hidden: user_nature==3,
                name:'visitortickets',
                component:visitortickets,
                meta: {title: '门票管理', icon: "circle", icon_on: 'circle_on' },
            },
            // {
            //     //参展门票
            //     path:'/ticketsExhibition',
            //     hidden: user_nature==1,
            //     name:'ticketsExhibition',
            //     component:ticketsExhibition,
            //     meta: {title: '门票管理', icon: "circle", icon_on: 'circle_on' },
            // },
          //直播间管理
            {
                path:'/broadcastoto',
                hidden: user_nature==1,
                name:'broadcastoto',
                component:broadcastoto,
                meta: {title: '直播间管理', icon: "circle", icon_on: 'circle_on'},
            },

          //子账号管理
          //   {
          //       path:'/subaccountManagement',
          //       hidden: false,
          //       name:'subaccountManagement',
          //       component:subaccountManagement,
          //       meta: {title: lan.subaccountManagement, icon: "circle", icon_on: 'circle_on' },
          //   },
            {
                path:'/jobList',
                name:'jobList',
                hidden: false,
                component:jobList,
                meta: {title: user_nature==1?'求职意向':'招聘岗位', icon: "circle", icon_on: 'circle_on' },
            },
          //参展记录  招聘岗位  新 面试记录(企业)
            {
                path:'/attendancerecord',
                hidden: user_nature==1 || superioruser_id != 0,
                name: "attendancerecord",
                component:attendancerecord,
                meta: {title: '面试记录', icon: "circle", icon_on: 'circle_on'},
            },
            {
                //面试记录(个人)
                path:'/exhibitionRecord',
                hidden: user_nature==3,
                name:'exhibitionRecord',
                component:exhibitionRecord,
                meta: {title: '面试记录', icon: "circle", icon_on: 'circle_on' },
            },

            // {
            //     path:'/exhibitorBbs',
            //     name:'exhibitorBbs',
            //     hidden: true,
            //     component:bbs,
            //     meta: {title: lan.sidebarName.forumTable, icon: "circle", icon_on: 'circle_on' },
            // },
            //展商体验
            {
                path:'/experience',
                hidden: false,
                name:'experience',
                component:experience,
                meta: {title: lan.sidebarName.experiencegz, icon: "circle", icon_on: 'circle_on' },
            },
            //门票管理
            // {
            //     path:'',
            //     hidden: false,
            //     name:'',
            //     component:experience,
            //     meta: {title: lan.sidebarName.ticketsManage, icon: "circle", icon_on: 'circle_on' },
            // }


          //参展席位
            // {
            //     path:'/ticketsExhibition',
            //     hidden: false,
            //     name:'ticketsExhibition',
            //     component:ticketsExhibition,
            //     meta: {title: lan.ticketsExhibition,icon: "circle", icon_on: 'circle_on', fn: 1},
            // },
            // {
            //     path:'/exhibitionList',
            //     name:'exhibitionwrap',
            //     hidden: true,
            //     component:exhibitionwrap,
            //     meta: {title: lan.sidebarName.guestList, icon: "circle", icon_on: 'circle_on' },
            //     children: [
            //         {
            //             path:'/exhibitionList/',
            //             name:'exhibitionList',
            //             hidden: true,
            //             component:exhibitionList,
            //         },
            //         {
            //             path:'/exhibitionList/guestList',
            //             name:'guestList',
            //             hidden: true,
            //             component:guestList,
            //         }
            //     ]
            // },

        ]
    },
    // {
    //     //观展管理
    //     name: "visitorAdmin",
    //     path: "/visitor",
    //     component: Layout,
    //     hidden: false,
    //     // meta: {title: lan.sidebarName.visitorAdmin, icon: "g_z_log", icon_on: "g_z_on"},
    //     meta: {title: lan.sidebarName.visitorAdmin, icon: "icon-user-gzlog", icon_on: "g_z_on"},
    //     children: [
    //         {
    //             //观展门票
    //             path:'/visitortickets',
    //             hidden: false,
    //             name:'visitortickets',
    //             component:visitortickets,
    //             meta: {title: lan.visitorTickets, icon: "circle", icon_on: 'circle_on' },
    //         },
    //             //观展记录
    //         {
    //             path:'/exhibitionRecord',
    //             hidden: false,
    //             name:'exhibitionRecord',
    //             component:exhibitionRecord,
    //             meta: {title: lan.exhibitionRecord, icon: "circle", icon_on: 'circle_on' },
    //         },
    //       //预约记录
    //         {
    //             path: "/make",
    //             hidden: false,
    //             name: "reservation",
    //             component: appointments,
    //             meta: {title: lan.bookRecord,icon: "circle", icon_on: 'circle_on'  }
    //         },
    //         {
    //             path:'/experience_gz',
    //             hidden: false,
    //             name:'experience_gz',
    //             component:experiencegz,
    //             meta: {title: lan.sidebarName.experiencegz, icon: "circle", icon_on: 'circle_on' },
    //         },
    //     ]
    //
    // },
    // {
    //     //观展管理
    //     name: "experience",
    //     path: "/experience",
    //     component: Layout,
    //     hidden: false,
    //     meta: {title: lan.sidebarName.experience, icon: "g_z_log", icon_on: "g_z_on"},
    //     children: [
    //         {
    //             //观展门票
    //             path:'/experience',
    //             redirect:to=>{return window.open('/forum.html?exhibition_id=28#/') },
    //            // hidden: false,
    //           //  name:'experience',
    //              //component:experience,
    //              meta: {title: lan.sidebarName.experience, icon: "circle", icon_on: 'circle_on' },
    //         },
    //             //观展记录
    //         {
    //             path:'/exhibitionRecord',
    //             hidden: false,
    //             name:'exhibitionRecord',
    //             component:exhibitionRecord,
    //             meta: {title: lan.exhibitionRecord, icon: "circle", icon_on: 'circle_on' },
    //         }
    //     ]

    // },


    {
        //个人中心
        path: "/",
        name:'userInfo',
        hidden: false,
        component:Layout,
        // meta: {title: lan.userInfo, icon: "info", icon_on: "user_on"},
        meta: {title: '账户管理', icon: user_nature==1?"user2_manage":"user_manage", icon_on: user_nature==1?"user2_manage_on":"user_manage_on"},
        children: [
            //在线简历
            {
                path:'/onlineResume',
                name:'onlineResume',
                hidden: user_nature==3,
                component:onlineResume,
                meta: {title: '在线简历', icon: "circle", icon_on: 'circle_on' },
            },
          //个人信息  企业信息
            {
                path:'/',
                name:'userInfo',
                hidden: false,
                component:userInfo,
                meta: {title: user_nature==1?'个人管理':'企业信息', icon: "circle", icon_on: 'circle_on' },
            },
          //修改密码  子账号管理
            {
                // path:'/editpassword',
                // name:'editpassword',
                // hidden: false,
                // component:editpassword,
                // meta: {title: lan.changePassword, icon: "circle", icon_on: 'circle_on' },

                path:'/subaccountManagement',
                hidden: user_nature==1,
                name:'subaccountManagement',
                component:subaccountManagement,
                meta: {title: lan.subaccountManagement, icon: "circle", icon_on: 'circle_on' },
            },
        ]
    },
    /*{
        //观展管理
        name: "visitorAdmin",
        path: "/visitor",
        component: Layout,
        hidden: false,
        // meta: {title: lan.sidebarName.visitorAdmin, icon: "g_z_log", icon_on: "g_z_on"},
        meta: {title: lan.sidebarName.ticketsManage, icon: "icon-user-gzlog", icon_on: "g_z_on"},
        children: [
            {
                //门票管理
                path:'/visitortickets',
                hidden: false,
                name:'visitortickets',
                component:visitortickets,
                meta: {title: lan.sidebarName.ticketsManage, icon: "circle", icon_on: 'circle_on' },
            },
            //观展记录
            // {
            //     path:'/exhibitionRecord',
            //     hidden: false,
            //     name:'exhibitionRecord',
            //     component:exhibitionRecord,
            //     meta: {title: lan.exhibitionRecord, icon: "circle", icon_on: 'circle_on' },
            // },
            // //预约记录
            // {
            //     path: "/make",
            //     hidden: false,
            //     name: "reservation",
            //     component: appointments,
            //     meta: {title: lan.bookRecord,icon: "circle", icon_on: 'circle_on'  }
            // },
            // {
            //     path:'/experience_gz',
            //     hidden: false,
            //     name:'experience_gz',
            //     component:experiencegz,
            //     meta: {title: lan.sidebarName.experiencegz, icon: "circle", icon_on: 'circle_on' },
            // },
        ]

    },*/
    {
        //订单管理
        path: "/orderList",
        name:'orderList',
        hidden: false,
        component: Layout,
        meta: {title: lan.sidebarName.orderManage, icon: "order", icon_on: 'order_on'},
        children: [
            //公告列表
            {
                path:'/orderList',
                name:'orderList',
                hidden: true,
                component:orderList,
                meta: {title: lan.sidebarName.orderManage, icon: "circle", icon_on: 'circle_on' },
            }
        ]
    },
    {
        //公告列表
        path: "/noticeList",
        name:'noticeList',
        hidden: false,
        component: Layout,
        meta: {title: lan.noticeList, icon: "notice", icon_on: 'notice_on'},
        children: [
          //公告列表
            {
                path:'/noticeList',
                name:'noticeList',
                hidden: true,
                component:noticeList,
                meta: {title: lan.noticeList, icon: "circle", icon_on: 'circle_on' },
            }
        ]
    }
]



const createRouter = () =>
  new Router({
      // mode: "history",
      routes: constantRoutes
  });

const router = createRouter();

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher;
}
// router.beforeEach((to, from, next) => {
//     console.log(to,"12313131313");
//     next();
// })
router.$addRoutes = params => {
    router.matcher = new Router({ scrollBehavior: () => ({ y: 0 }) }).matcher;
    router.addRoutes(params);
};
export default router;


